const isCallback = (
    maybeFunction: unknown | ((...args: any[]) => void),
): maybeFunction is (...args: any[]) => void => typeof maybeFunction === 'function';

export default isCallback;
